<template>
    <div class="col-md promo">
        <div class="input-group">
            <input type="text" class="form-control" placeholder="Enter Promo Code" aria-label="promocode" v-model="promoCode" @keyup.enter="addPromo">

            <div class="input-group-append" id="button-addon4">
                <button class="btn btn-danger" type="button" @click="addPromo">Add Promo</button>
            </div>
        </div>
        <div class="text-danger danger mt-2">
            {{ promoCodeError }}
        </div>
        <div class="spacer"></div>
        <h3 v-if="this.localPromos.length">Active Promotions</h3>
        <div v-if="loading" class="loading"></div>
        <div class="row promo" v-for="promo, i in localPromos">
            <div class="col-1"><a @click="removePromo(i, promo.code)">X</a></div>
            <div class="col-4 m-0 p-0 code">{{ formatPromoCode(promo) }}</div>
            <div class="col">{{ promo.description }}</div>
        </div>

        <p class="disclaimer" v-for="adjustment in adjustments">
            Savings with ({{ formatPromoNames(adjustment.promos) }}) are accumulated over the life of the Rent To Own Agreement.
            This code will save you ${{ adjustment.savings }} over {{ adjustment.term }} {{ getPriceLabelPeriod(adjustment) }}.
        </p>
    </div>
</template>

<script>
    import { Raven } from 'vue-raven';
    import reject from 'lodash/reject'
    import NewsletterSignup from './cart/NewsletterSignup.vue';

    import {ServiceFactory} from '../../../../../shared/assets/js/services/ServiceFactory';
    const PromoService = ServiceFactory.get('promos');

    export default {
        props: ['promos', 'adjustments'],

        components: {NewsletterSignup},

        data() {
            return {
                localPromos: {},
                promoCode: null,
                promoCodeError: null,
                loading: false,
            }
        },

        created() {
            this.localPromos = this.promos;
        },

        watch: {
            promos: function () {
                this.localPromos = this.promos;
                this.loading = false;
            },
        },

        methods: {

            getPriceLabelPeriod(adjustment) {
                var label = adjustment.priceLabel.toLowerCase();
                if (label.indexOf('month') !== -1) {
                    return 'Months';
                }
                if (label.indexOf('week') !== -1) {
                    return 'Weeks';
                }

                return '';
            },

            formatPromoCode(promo) {
                if (promo.actualCode) {
                    return promo.actualCode;
                }

                return promo.code;
            },

            formatPromoNames(promos) {
                var mapped = PromoService.mapPromoCodesToPromos(this.localPromos);

                var result = promos.map(function (promo) {
                    if(!mapped[promo]) {
                        Raven.captureMessage("Undefined promo!", {
                            level: "warning",
                        });
                        return '';
                    }

                    return PromoService.formatPromoCode(mapped[promo]);
                });

                return result.toString();
            },

            async addPromo() {
                this.$emit('updating');
                this.loading = true;
                this.promoCodeError = null;
                try {
                    await PromoService.add(this.promoCode);
                } catch (error) {
                    this.promoCodeError = error.response.data.promoCode[0];
                }

                this.promoCode = null;
                this.$emit('refresh');
            },

            async removePromo(i, promoCode) {
                this.$emit('updating');
                this.localPromos = reject(this.promos, (promo) => promo.code === promoCode);

                await PromoService.delete(promoCode);

                this.$emit('refresh');
            },
        }
    }
</script>
